import React from "react";

import classnames from "classnames";
import _ from "underscore";

import { deductibleOptions, networkOptionsMock, carrierOptions, doctorVisitOptionsMock, specialistVisitOptionsMock } from "../shared/FilterData";
import MultiSelectFilter from "../shared/MultiSelectFilter";
import SingleOptionFilter from "../shared/SingleOptionFilter";
import Icon from "Common/Icon";

import ModalFilterButton from "./mobileFilterBarDumb/ModalFilterButton";

import type { MedicalPlan } from "Utils/types";

import makeBem from "Utils/makeBem";

const bem = makeBem("FilterBarDumb");

type Props = {
  allPlans: Array<MedicalPlan>;
  filterConfig: any;
  onChangeFilter: (arg0: string, arg1: any) => void;
  companyProfile: any;
  carriersInRegion: Array<string>;
};

class FilterBarDumb extends React.Component<Props> {
  render() {
    // NOTE: looks like "selected" state was not implemented here
    // adding it would be out of scope for this PR
    return (
      <div className={classnames(bem("container"))}>
        <ModalFilterButton trackingKey="deductible" title="Deductible" renderFilter={this.renderDeductibleFilter} {...this.props}>
          Deductible&nbsp;
          <Icon icon="caret-down" flavor="solid" />
        </ModalFilterButton>
        <ModalFilterButton trackingKey="network" title="Network" renderFilter={this.renderNetworkFilter} {...this.props}>
          Network&nbsp;
          <Icon icon="caret-down" flavor="solid" />
        </ModalFilterButton>
        <ModalFilterButton trackingKey="carriers" title="Carriers" renderFilter={this.renderCarrierFilter} {...this.props}>
          Carriers&nbsp;
          <Icon icon="caret-down" flavor="solid" />
        </ModalFilterButton>
        <ModalFilterButton trackingKey="doctor_visits" title="Doctor Visits" renderFilter={this.renderDoctorVisitFilter} {...this.props}>
          Doctor Visits&nbsp;
          <Icon icon="caret-down" flavor="solid" />
        </ModalFilterButton>
        <ModalFilterButton trackingKey="prescriptions" title="Prescriptions" renderFilter={this.renderSpecialistVisitFilter} {...this.props}>
          Prescriptions&nbsp;
          <Icon icon="caret-down" flavor="solid" />
        </ModalFilterButton>
        <ModalFilterButton trackingKey="other_filters" title="Other Filters" renderFilter={this.renderMoreFilters} {...this.props}>
          Other Filters&nbsp;
          <Icon icon="caret-down" flavor="solid" />
        </ModalFilterButton>
      </div>
    );
  }

  renderDeductibleFilter(props: Props) {
    const options = deductibleOptions;
    return (
      <MultiSelectFilter
        {...props}
        options={options}
        defaultOptions={options.map((x) => x.value)}
        defaultSelect
        filterKey="deductible"
        menuTitle="Deductible"
      />
    );
  }

  renderCarrierFilter(props: Props) {
    const { carriersInRegion } = props;
    const options = carrierOptions(carriersInRegion);

    return <MultiSelectFilter {...props} options={options} defaultOptions={carriersInRegion} defaultSelect filterKey="carrier" menuTitle="Carriers" />;
  }

  renderNetworkFilter(props: Props) {
    const options = networkOptionsMock();

    return (
      <MultiSelectFilter {...props} options={options} defaultOptions={options.map((x) => x.value)} defaultSelect filterKey="plan_type" menuTitle="Networks" />
    );
  }

  renderDoctorVisitFilter(props: Props) {
    const options = doctorVisitOptionsMock;

    return (
      <MultiSelectFilter
        {...props}
        options={options}
        defaultOptions={options.map((x) => x.value)}
        defaultSelect
        filterKey="estimated_costs.pcp_visit"
        menuTitle="Doctor Visits"
      />
    );
  }

  renderSpecialistVisitFilter(props: Props) {
    const options = specialistVisitOptionsMock;

    return (
      <MultiSelectFilter
        {...props}
        options={options}
        defaultOptions={options.map((x) => x.value)}
        defaultSelect
        filterKey="estimated_costs.specialist_visit"
        menuTitle="Specialist Visits"
      />
    );
  }

  renderMoreFilters(props: Props) {
    const { allPlans, filterConfig, onChangeFilter, companyProfile } = props;
    return (
      <ul className="p-0 list-none si-menu">
        <SingleOptionFilter
          {...props}
          filterConfig={filterConfig}
          allPlans={allPlans}
          filterKey="out_of_state"
          handleChangeFilter={onChangeFilter}
          filterLabel="Out of State Employee Coverage"
        />

        <SingleOptionFilter
          {...props}
          filterConfig={filterConfig}
          allPlans={allPlans}
          filterKey="hsa_eligible"
          handleChangeFilter={onChangeFilter}
          filterLabel="Health Savings Account (HSA) Eligible"
        />
      </ul>
    );
  }
}

export default FilterBarDumb;
